import React from 'react'
import { IApplication } from 'core/interfaces/Application'
import { IconComponent } from 'core/components/common/IconComponent'

interface PromptHeaderProps {
  application: IApplication
}

export const ApplicationHeader: React.FC<PromptHeaderProps> = ({
  application,
}) => {
  const { nomApplication, service, tags } = application

  return (
    <div className="prompt-header">
      <IconComponent
        iconInfo={application?.icone ?? application?.service.icone}
        className="h-[40px] w-[40px]"
      />
      <div className="flex flex-col ml-10px">
        <div className="text-gray-1250 uppercase text-[11px]">
          {service?.nomService}
        </div>
        <div className="font-medium">{nomApplication}</div>
      </div>
      <div className="hidden md:flex md:flex-row md:h-full md:items-center">
        <div className="tags">
          {tags &&
            tags.map((tag) => (
              <div className="tag-button" key={tag.id}>
                {tag.nomTag}
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}
